/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $('.ad_to_cart_coll').click(function(){    
//   var ID = $(this).attr("data-var_id");
//   addItemToCart( ID, 1);   // paste your id product number
//   $('.cart_dr').trigger( "click" );
// });
// function addItemToCart(variant_id, qty) {
//   data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() { 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true  //this code is for prestige theme, is to refresh the cart
//       }));
//     }   
    
//   }); 
 
// }

/* quick add to cart buttons for drawer - collection/product pages */
jQuery(document).ready(function($){
  $('body').on('click','.Button_ATC',function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $('.PageOverlay').addClass('is-visible');
    var id = $(this).attr('data-var_id'); 
    var i = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: { id: id, quantity: i },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);            
      },
      success: function() {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: id,
            quantity: 1
          }
        }));
        // $.get( "/cart?view=drawer", function( data ) {               
        //   $('#sidebar-cart .Drawer__Content').html($(data).find('.Drawer__Content').html());    
        // });
        // $('#sidebar-cart').attr('aria-hidden','false');
        // $.getJSON('/cart.js', function(cart){
        //   $('.Header__CartCount').text(cart.item_count);
        // });
      }         
    });
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
  /* slider for thumbnails - product pages */
  if($(window).width() > 1140){
    $('.Product__SlideshowNavScroller').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1
    });
  }
})
/* lazyload embedded youtube videos with custom thumbs */
$(function() {

    var youtube = document.querySelectorAll( ".youtube" );
    
    for (var i = 0; i < youtube.length; i++) {
        
        var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
        
        var image = new Image();
                image.src = source;
                image.alt = 'Play Klean Kanteen YouTube Video';
                image.title = 'Play Klean Kanteen YouTube Video';
                image.addEventListener( "load", function() {
                    youtube[ i ].appendChild( image );
                }( i ) );
        
                youtube[i].addEventListener( "click", function() {

                    var iframe = document.createElement( "iframe" );

                            iframe.setAttribute( "frameborder", "0" );
                  			iframe.setAttribute( "title", "Play Klean Kanteen Video" );
                            iframe.setAttribute( "allowfullscreen", "" );
							iframe.setAttribute( "allow", "autoplay" );                            
                            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

                            this.innerHTML = "";
                            this.appendChild( iframe );
                } );    
    };
    
} )();
